module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-hb.80e5aecb.png";